import React from "react";
import { Box, Typography, Card, CardContent, Button } from "@mui/material";

const HelpTab = () => {
  return (
    <Box sx={{ maxWidth: 800, mx: "auto", py: 3 }}>
      <Typography variant="h6" gutterBottom>
        Help & Support
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        Find answers to common questions or contact our support team
      </Typography>

      {/* Frequently Asked Questions */}
      <Card variant="outlined" sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="subtitle1" gutterBottom>
            Frequently Asked Questions
          </Typography>
          {/* Add FAQs here */}
        </CardContent>
      </Card>

      {/* Contact Support Section */}
      <Card variant="outlined">
        <CardContent>
          <Typography variant="subtitle1" gutterBottom>
            Contact Support
          </Typography>
          <Typography variant="body2" paragraph>
            Need help? Our support team is available Monday-Friday, 9am-5pm.
          </Typography>
          <Button disabled variant="contained" sx={{ borderRadius: 2 }}>
            Contact Support
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default HelpTab;
